module.exports = __webpack_public_path__ + "img/fee63c9.png";